export const categories = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，温暖治愈的韩漫佳作' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '穿越异世界、魔法冒险，脑洞大开的奇幻旅程' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', description: '热血激斗、精彩对决，让人肾上腺素飙升' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '烧脑推理、反转不断，扣人心弦的悬疑故事' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默、笑点密集，解压放松首选' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-open-line', description: '深刻感人、引人深思的剧情向漫画' },
  { slug: 'jingli', name: '惊悚', icon: 'ri-ghost-line', description: '恐怖刺激、细思极恐的惊悚漫画' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界、人工智能，硬核科幻想象' },
];

export const comics = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    slug: 'badao-zongcai-qiyue-xinniang',
    category: 'lianai',
    author: '韩小漫',
    artist: '画师小李',
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20art%2C%20beautiful%20female%20character%20with%20long%20dark%20hair%20in%20elegant%20dress%2C%20handsome%20male%20lead%20in%20suit%2C%20soft%20warm%20lighting%2C%20modern%20luxury%20setting%2C%20anime%20style%20illustration%2C%20clean%20composition%20on%20light%20cream%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '为偿还家族债务，她签下了一份特殊的契约——成为霸道总裁的契约新娘。本以为只是一场交易，却没想到这冷酷的男人竟然慢慢走进了她的心里。然而，前女友的回归，商业对手的阴谋，让这段感情充满了变数……',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 契约的开始' : i === 85 ? ' 终章：真爱永恒' : ''}`,
      updateDate: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['总裁', '契约婚姻', '甜宠', '都市'],
    updateDay: '每周二、五更新',
  },
  {
    id: 2,
    title: '异世界美食家',
    slug: 'yishijie-meishijia',
    category: 'qihuan',
    author: '金大厨',
    artist: '李画笔',
    status: '连载中',
    rating: 9.4,
    views: 8920000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20webtoon%20cover%2C%20young%20chef%20character%20in%20apron%20holding%20delicious%20food%20in%20magical%20medieval%20setting%2C%20warm%20golden%20lighting%2C%20colorful%20ingredients%20floating%2C%20anime%20style%20illustration%2C%20appetizing%20food%20art%20on%20cream%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '顶级厨师金宇赫在一次意外中穿越到了剑与魔法的异世界。在这里，他发现自己掌握的现代烹饪技巧竟然能做出带有神奇效果的美食！跟在身边的精灵少女、爱吃美食的龙族公主，他的异世界冒险从厨房开始！',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 穿越的厨师' : ''}`,
      updateDate: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['异世界', '美食', '冒险', '搞笑'],
    updateDay: '每周一、四更新',
  },
  {
    id: 3,
    title: '暗夜追踪者',
    slug: 'anye-zhuizongzhe',
    category: 'dongzuo',
    author: '朴武',
    artist: '崔影',
    status: '已完结',
    rating: 9.7,
    views: 15300000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20noir%20webtoon%20cover%2C%20tough%20male%20detective%20in%20black%20leather%20jacket%20in%20dark%20alley%2C%20rainy%20night%20scene%2C%20neon%20signs%20reflection%2C%20cool%20atmospheric%20anime%20style%2C%20dramatic%20lighting%20on%20dark%20cream%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '前特种兵韩俊浩退役后成为私家侦探，专门追踪警方无法解决的神秘案件。一桩看似普通的失踪案，却牵扯出一个横跨多国的犯罪网络。在追查真相的路上，他遇到了同样在寻找失踪妹妹的神秘女黑客……',
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 消失的她' : i === 119 ? ' 终章：正义裁决' : ''}`,
      updateDate: new Date(2025, 11, 30 - i).toISOString().split('T')[0],
      isFree: true,
    })),
    tags: ['动作', '悬疑', '侦探', '犯罪'],
    updateDay: '已完结',
  },
  {
    id: 4,
    title: '第七夜的秘密',
    slug: 'diqiye-de-mimi',
    category: 'xuanyi',
    author: '郑推理',
    artist: '吴暗',
    status: '连载中',
    rating: 9.5,
    views: 6780000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20webtoon%20cover%2C%20female%20protagonist%20looking%20suspicious%20through%20half%20opened%20door%2C%20moonlit%20night%20scene%2C%20old%20mansion%20interior%2C%20tense%20atmosphere%2C%20anime%20style%2C%20dark%20mysterious%20vibe%20on%20cream%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '搬进大学附近的出租公寓后，林雪儿发现每到第七个夜晚，楼道里会响起奇怪的脚步声。室友们对此讳莫如深，房东的反应更是诡异。当她决定揭开真相时，才发现自己已经被卷入了一场二十年前的谋杀案……',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 3 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['悬疑', '恐怖', '校园', '推理'],
    updateDay: '每周三更新',
  },
  {
    id: 5,
    title: '废柴逆袭日记',
    slug: 'feichai-nixi-riji',
    category: 'gaoxiao',
    author: '欢欢',
    artist: '乐乐',
    status: '连载中',
    rating: 9.3,
    views: 11200000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20webtoon%20cover%2C%20funny%20exaggerated%20expression%20of%20male%20character%20tripping%2C%20colorful%20chaotic%20school%20setting%2C%20bright%20sunny%20day%2C%20humorous%20anime%20style%2C%20energetic%20composition%20on%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '全校倒数第一的废柴高中生金小胖，在一次意外电击后获得了"逆袭系统"。从此，学渣变学霸、废柴变男神！但是系统的任务总是出人意料，让他啼笑皆非的逆袭之路就此展开……',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
      isFree: i < 15,
    })),
    tags: ['搞笑', '校园', '系统', '逆袭'],
    updateDay: '每周五更新',
  },
  {
    id: 6,
    title: '重生之商业帝国',
    slug: 'chongsheng-shangye-diguo',
    category: 'juqing',
    author: '商道',
    artist: '金笔',
    status: '连载中',
    rating: 9.6,
    views: 9650000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20webtoon%20cover%2C%20confident%20male%20lead%20in%20luxury%20suit%20standing%20in%20modern%20office%20overlooking%20city%2C%20skyscrapers%20through%20window%2C%20professional%20atmosphere%2C%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '他被最信任的合伙人背叛，一夜之间失去了一切。幸运的是，他重生了，回到了二十年前创业的起点。带着前世的记忆和商业智慧，他誓要打造一个无人能撼动的商业帝国，同时揪出那个隐藏在暗处的敌人……',
    chapters: Array.from({ length: 92 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
      isFree: i < 12,
    })),
    tags: ['重生', '商战', '逆袭', '剧情'],
    updateDay: '每周一、三、五更新',
  },
  {
    id: 7,
    title: '灵异便利店',
    slug: 'lingyi-bianlidian',
    category: 'jingli',
    author: '鬼鬼',
    artist: '暗影',
    status: '连载中',
    rating: 9.2,
    views: 5340000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20supernatural%20webtoon%20cover%2C%20creepy%20convenience%20store%20at%20night%20with%20ghostly%20figure%20behind%20counter%2C%20flickering%20neon%20sign%2C%20dark%20atmosphere%2C%20anime%20style%20horror%20on%20cream%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '深夜便利店打工的大学生小张，发现每到午夜12点，店里就会出现一些"特别的顾客"。他们不是活人，而是带着未了心愿的鬼魂。为了帮他们完成心愿，小张开始了一场跨越阴阳两界的冒险……',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 5 - i).toISOString().split('T')[0],
      isFree: i < 8,
    })),
    tags: ['惊悚', '灵异', '治愈', '单元剧'],
    updateDay: '每周六更新',
  },
  {
    id: 8,
    title: '机甲纪元',
    slug: 'jijia-jiyuan',
    category: 'kehuan',
    author: '柯学',
    artist: '机甲控',
    status: '连载中',
    rating: 9.5,
    views: 7450000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20mecha%20webtoon%20cover%2C%20giant%20robot%20battle%20in%20futuristic%20city%2C%20young%20pilot%20in%20cockpit%2C%20explosions%20and%20energy%20beams%2C%20cyberpunk%20aesthetic%2C%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '2147年，地球资源枯竭，人类依靠巨型机甲在星际间争夺生存资源。少年林宇在垃圾场发现了一台被遗弃的远古机甲，这台机甲竟然搭载了传说中的AI"天启"系统。他的命运，就此与人类的未来紧密相连……',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['科幻', '机甲', '星际', '战争'],
    updateDay: '每周四、日更新',
  },
  {
    id: 9,
    title: '微微一笑很倾城',
    slug: 'weiwei-yixiao-henqingcheng',
    category: 'lianai',
    author: '甜心',
    artist: '暖阳',
    status: '已完结',
    rating: 9.8,
    views: 20100000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20college%20romance%20webtoon%20cover%2C%20beautiful%20couple%20sitting%20on%20park%20bench%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%2C%20sweet%20romantic%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '计算机系学霸苏暖暖在游戏中遇到了技术大神"一叶知秋"，两人在虚拟世界中配合默契。没想到在现实中，她发现这个神秘的队友竟然是系里那个冷面上司——帅气却毒舌的顾学长！线上甜蜜、线下斗嘴的爆笑恋爱故事就此展开。',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 遇见大神' : i === 97 ? ' 终章：余生有你' : ''}`,
      updateDate: new Date(2025, 10, 30 - i).toISOString().split('T')[0],
      isFree: true,
    })),
    tags: ['校园', '甜宠', '游戏', '治愈'],
    updateDay: '已完结',
  },
  {
    id: 10,
    title: '剑与玫瑰',
    slug: 'jian-yu-meigui',
    category: 'qihuan',
    author: '剑士',
    artist: '花匠',
    status: '连载中',
    rating: 9.4,
    views: 8120000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20webtoon%20cover%2C%20female%20knight%20with%20sword%20in%20medieval%20armor%20standing%20in%20rose%20garden%2C%20castle%20in%20background%2C%20golden%20sunset%20lighting%2C%20elegant%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '被誉为"帝国之剑"的女骑士团长艾琳娜，在一次任务中救下了一个失忆的神秘少年。少年自称是邻国的王子，却对王室之事一无所知。随着相处，艾琳娜发现自己对少年产生了超越任务的情感，而一场牵动两国命运的巨大阴谋也悄然浮出水面……',
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['奇幻', '骑士', '恋爱', '宫廷'],
    updateDay: '每周三、六更新',
  },
  {
    id: 11,
    title: '格斗之王',
    slug: 'gedou-zhiwang',
    category: 'dongzuo',
    author: '拳霸',
    artist: '墨武',
    status: '连载中',
    rating: 9.3,
    views: 10300000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20fighting%20webtoon%20cover%2C%20fierce%20fighter%20in%20dynamic%20punching%20pose%20in%20ring%2C%20crowd%20cheering%2C%20dramatic%20spotlight%2C%20intense%20action%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在地下格斗界，有一个不败传说——"铁拳"姜哲。他从街头混混一路打到世界冠军，靠的是拳头和不服输的意志。但是当他的身世之谜被揭开，他才发现自己的身世竟然与格斗界最大的阴谋息息相关……',
    chapters: Array.from({ length: 66 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 3 - i).toISOString().split('T')[0],
      isFree: i < 10,
    })),
    tags: ['格斗', '热血', '竞技', '复仇'],
    updateDay: '每周二、四更新',
  },
  {
    id: 12,
    title: '时间循环者',
    slug: 'shijian-xunhuanzhe',
    category: 'xuanyi',
    author: '轮回',
    artist: '时雨',
    status: '连载中',
    rating: 9.6,
    views: 7890000,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20loop%20mystery%20webtoon%20cover%2C%20male%20protagonist%20surrounded%20by%20floating%20clock%20faces%2C%20surreal%20abstract%20background%2C%20pocket%20watches%20and%20gears%2C%20mind-bending%20anime%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '普通上班族陈明每天醒来都发现自己回到了昨天。在这个无限循环的时间线中，他唯一能做的就是不断尝试改变未来。然而每一次改变都带来了意想不到的后果，而那个在循环中一次次出现在他身边的神秘女孩，似乎知道一切的真相……',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: new Date(2026, 7, 4 - i).toISOString().split('T')[0],
      isFree: i < 8,
    })),
    tags: ['时间循环', '悬疑', '科幻', '爱情'],
    updateDay: '每周日更新',
  },
];

export const faqs = [
  {
    question: '韩漫画网的漫画都是正版吗？',
    answer: '是的，韩漫画网所有漫画均获得正版授权，我们与多家韩国知名漫画平台和出版社建立了长期合作关系，确保每一位读者都能安心享受高质量的漫画内容。我们严格遵守版权法规，坚决打击盗版行为。',
  },
  {
    question: '免费漫画弹窗入口如何使用？',
    answer: '您可以通过网站首页和漫画详情页的免费漫画弹窗入口，直接进入免费漫画专区。免费专区每日更新热门漫画的免费章节，无需注册即可阅读。弹窗入口会根据您的阅读偏好智能推荐您可能喜欢的免费漫画。',
  },
  {
    question: '如何在韩漫画网找到想看的漫画？',
    answer: '您可以通过首页的分类导航栏按类型浏览，也可以在搜索框中直接输入漫画名称或作者名进行搜索。此外，首页的"热门推荐"和"最新更新"板块也会帮您发现精彩内容。支持恋爱、奇幻、动作、悬疑等多种分类筛选。',
  },
  {
    question: '韩漫画网支持哪些设备阅读？',
    answer: '韩漫画网采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。推荐使用Chrome、Safari等主流浏览器访问以获得最佳效果。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '每部漫画的更新频率不同，一般在每周固定日期更新1-3话。具体更新日期可以在漫画详情页的"更新日"标签中查看。热门连载漫画通常保持稳定的更新节奏，已完结作品可以一口气畅读全部章节。',
  },
  {
    question: '是否需要注册才能阅读漫画？',
    answer: '韩漫画网的免费漫画弹窗入口无需注册即可直接阅读。部分最新连载章节可能需要注册免费账号后解锁。注册过程简单快捷，只需提供邮箱地址即可完成，我们承诺保护您的个人信息安全。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: '',
    rating: 5,
    comment: '每天晚上必刷韩漫画网！画风太美了，剧情也超棒，最喜欢《暗夜追踪者》，一口气看到凌晨三点！',
    date: '2026-07-15',
  },
  {
    name: '星辰大海',
    avatar: '',
    rating: 5,
    comment: '找了好久的韩漫资源终于在这里找到了正版！画质清晰，翻译也很到位，比盗版站强太多了。',
    date: '2026-07-20',
  },
  {
    name: '漫画迷小王',
    avatar: '',
    rating: 5,
    comment: '免费漫画弹窗入口真的超赞，每天都有新章节免费看。推荐给了好多朋友，都说好用！',
    date: '2026-07-25',
  },
  {
    name: '甜甜圈',
    avatar: '',
    rating: 4,
    comment: '分类很齐全，想看的韩漫基本都有。如果能有更多完结作品就更好了，期待平台越做越大！',
    date: '2026-08-01',
  },
  {
    name: '夜行者',
    avatar: '',
    rating: 5,
    comment: '作为韩漫重度爱好者，真心觉得韩漫画网是目前国内最好的韩漫平台。正版、更新快、体验好！',
    date: '2026-08-02',
  },
];

export const aboutInfo = {
  brandName: '韩漫画网',
  founded: '2023年',
  mission: '让每一位漫画爱好者都能轻松享受正版、高质量的韩漫阅读体验',
  description: '韩漫画网是国内领先的韩漫在线阅读平台，致力于为华语读者提供最全面、最优质的韩国漫画资源。我们与多家韩国顶级漫画平台和出版社建立了深度合作关系，确保所有漫画均为正版授权，内容安全可靠。',
  features: [
    { title: '正版授权', description: '所有漫画均获得官方正版授权，内容安全可靠，让您放心阅读。', icon: 'ri-shield-check-line' },
    { title: '海量资源', description: '涵盖恋爱、奇幻、动作、悬疑、搞笑等多种类型，持续更新中。', icon: 'ri-stack-line' },
    { title: '免费入口', description: '设有免费漫画弹窗入口，无需付费即可畅读海量精选漫画。', icon: 'ri-gift-line' },
    { title: '高清画质', description: '采用高清扫描和数字处理技术，还原漫画最真实的画面细节。', icon: 'ri-image-line' },
    { title: '专业翻译', description: '拥有专业韩语翻译团队，确保翻译准确自然，保留原汁原味。', icon: 'ri-translate-2' },
    { title: '多端适配', description: '完美适配电脑、平板和手机，随时随地享受阅读乐趣。', icon: 'ri-device-line' },
  ],
  contact: {
    email: 'contact@hanmanhua.com',
    wechat: 'hanmanhua_official',
    qq: '1234567890',
    address: '北京市朝阳区望京SOHO T1 1206室',
  },
};